import { alpha } from '@mui/material/styles';
import type { Theme } from '@mui/material/styles';

const STRIPED_ROW_ALPHA = 0.012;
const UNREAD_ROW_ALPHA = 0.05;
const UNREAD_ROW_DARK_ALPHA = 0.16;
const UNREAD_HOVER_ALPHA = 0.08;
const UNREAD_HOVER_DARK_ALPHA = 0.24;

export const getStripedRowBackground = (theme: Theme) =>
  alpha(theme.palette.text.primary, STRIPED_ROW_ALPHA);

export const getUnreadRowBackground = (theme: Theme, hovered = false) => {
  const opacity = hovered
    ? theme.palette.mode === 'dark'
      ? UNREAD_HOVER_DARK_ALPHA
      : UNREAD_HOVER_ALPHA
    : theme.palette.mode === 'dark'
      ? UNREAD_ROW_DARK_ALPHA
      : UNREAD_ROW_ALPHA;

  return alpha(theme.palette.primary.main, opacity);
};

export const getOpaqueRowBackground = (theme: Theme, color: string, weight: number) =>
  `color-mix(in srgb, ${theme.palette.background.paper} ${100 - weight}%, ${color} ${weight}%)`;

export const getStickyStripedRowBackground = (theme: Theme) =>
  getOpaqueRowBackground(theme, theme.palette.text.primary, 1.2);

export const getStickyHoverRowBackground = (theme: Theme) =>
  getOpaqueRowBackground(theme, theme.palette.action.hover, 8);

export const getStickySelectedRowBackground = (theme: Theme) =>
  getOpaqueRowBackground(theme, theme.palette.action.selected, 12);

export const getStickyUnreadRowBackground = (theme: Theme, hovered = false) =>
  getOpaqueRowBackground(
    theme,
    theme.palette.primary.main,
    theme.palette.mode === 'dark' ? (hovered ? 24 : 16) : hovered ? 8 : 5
  );
